(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() { if (this.header) document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    disconnectedCallback() { this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp); window.removeEventListener('scroll', this.onScrollHandler); }
    createObserver() { let observer = new IntersectionObserver((entries, observer) => { this.headerBounds = entries[0].intersectionRect; observer.disconnect(); }); observer.observe(this.header); }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) { this.header.classList.add('scrolled-past-header'); if (this.preventHide) return; requestAnimationFrame(this.hide.bind(this)); }
      else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) { this.header.classList.add('scrolled-past-header'); if (!this.preventReveal) requestAnimationFrame(this.reveal.bind(this)); else { window.clearTimeout(this.isScrolling); this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66); requestAnimationFrame(this.hide.bind(this)); } }
      else if (scrollTop <= this.headerBounds.top) { this.header.classList.remove('scrolled-past-header'); requestAnimationFrame(this.reset.bind(this)); }
      this.currentScrollTop = scrollTop;
    }
    hide() { if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky'); this.closeMenuDisclosure(); this.closeSearchModal(); }
    reveal() { if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-sticky', 'animate'); this.header.classList.remove('shopify-section-header-hidden'); }
    reset() { if (this.headerIsAlwaysSticky) return; this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate'); }
    closeMenuDisclosure() { this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu'); this.disclosures.forEach((disclosure) => disclosure.close()); }
    closeSearchModal() { this.searchModal = this.searchModal || this.header.querySelector('details-modal'); if (this.searchModal && typeof this.searchModal.close === 'function') this.searchModal.close(false); }
  }
  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legacy-collection-edit"] && !Shopify.designMode) return;
  try {
    
function initializeCollectionExplorers(scope) {
  scope.querySelectorAll('[data-collection-explorer]').forEach(explorer => {
    if (explorer.dataset.initialized) return;
    explorer.dataset.initialized = 'true';
    const shuffle = items => {
      for (let i = items.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [items[i], items[j]] = [items[j], items[i]];
      }
      return items;
    };
    explorer.querySelectorAll('.legacy-edit__products').forEach(grid => {
      const cards = [...grid.children].filter(card => card.classList.contains('legacy-home-card'));
      const required = cards.filter(card => card.hasAttribute('data-rotation-required'));
      const pool = shuffle(cards.filter(card => !card.hasAttribute('data-rotation-required')));
      const featured = grid.classList.contains('legacy-edit__products--featured');
      const count = featured ? 7 : 6;
      let cursor = 0;
      const groupCursors = new Map();
      const groups = [...new Set(pool.map(card => card.dataset.rotationGroup).filter(Boolean))];
      const show = () => {
        let selected = [...required];
        if (featured && groups.length) {
          const seen = new Set(required.map(card => card.dataset.productId));
          groups.forEach(group => {
            if (selected.length >= count) return;
            const candidates = pool.filter(card => card.dataset.rotationGroup === group);
            const offset = groupCursors.get(group) || 0;
            for (let i = 0; i < candidates.length; i++) {
              const candidate = candidates[(offset + i) % candidates.length];
              if (!seen.has(candidate.dataset.productId)) {
                selected.push(candidate);
                seen.add(candidate.dataset.productId);
                groupCursors.set(group, (offset + i + 1) % candidates.length);
                break;
              }
            }
          });
        } else {
          for (let i = 0; i < Math.min(count - required.length, pool.length); i++) {
            selected.push(pool[(cursor + i) % pool.length]);
          }
          cursor = pool.length ? (cursor + count - required.length) % pool.length : 0;
        }
        selected = featured && required.length ? [...required, ...shuffle(selected.filter(card => !required.includes(card)))] : shuffle(selected);
        cards.forEach(card => { card.hidden = !selected.includes(card); });
        selected.forEach(card => grid.appendChild(card));
      };
      show();
      const more = grid.closest('[data-collection-panel]').querySelector('[data-show-more-products]');
      if (more) {
        more.hidden = cards.length <= count;
        more.addEventListener('click', show);
      }
    });
    const buttons = [...explorer.querySelectorAll('[data-collection-choice]')];
    const panels = [...explorer.querySelectorAll('[data-collection-panel]')];
    const select = button => {
      buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      panels.forEach(panel => { panel.hidden = panel.dataset.collectionPanel !== button.dataset.collectionChoice; });
    };
    buttons.forEach(button => {
      button.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') select(button);
      });
      button.addEventListener('click', () => select(button));
      button.addEventListener('focus', () => select(button));
      button.addEventListener('keydown', event => {
        const index = buttons.indexOf(button);
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
        if (event.key === 'ArrowLeft') next = (index + buttons.length - 1) % buttons.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = buttons.length - 1;
        if (next !== undefined) { event.preventDefault(); buttons[next].focus(); }
      });
    });
  });
}
initializeCollectionExplorers(document);
document.addEventListener('shopify:section:load', event => initializeCollectionExplorers(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legacy-collection-preview"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const link = event.target.closest('.legacy-collection-preview__card a[href*="launch_item="]');
  if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  window.location.assign(link.href);
}, true);

document.addEventListener('click', function(event) {
  const filter = event.target.closest('[data-launch-category],[data-launch-audience],[data-launch-concept]');
  if (filter) {
    const header = filter.closest('[data-launch-collection]');
    const preview = Array.from(document.querySelectorAll('[data-launch-preview]')).find(item => item.dataset.launchPreview === header.dataset.launchCollection);
    if (!preview) return;
    const kind = filter.hasAttribute('data-launch-category') ? 'category' : filter.hasAttribute('data-launch-audience') ? 'audience' : 'concept';
    const attr='data-launch-'+kind;
    header.dataset[kind]=filter.getAttribute(attr);
    header.querySelectorAll('['+attr+']').forEach(button=>button.setAttribute('aria-pressed',String(button===filter)));
    let visible=0;
    preview.querySelectorAll('.legacy-collection-preview__card').forEach(card=>{
      const category=header.dataset.category||'all',audience=header.dataset.audience||'all',concept=header.dataset.concept||'all';
      const matches=(category==='all'||card.dataset.launchCategories.split(',').includes(category))&&(audience==='all'||card.dataset.audiences.split(',').includes(audience))&&(concept==='all'||card.dataset.concept===concept);
      card.hidden=!matches;if(matches)visible++;
    });
    preview.querySelector('[data-launch-empty]').hidden=visible>0;
    return;
  }
  const swatch = event.target.closest('.legacy-preview-swatch');
  if (!swatch) return;
  const card = swatch.closest('.legacy-collection-preview__card');
  const primary = card.querySelector('.legacy-collection-preview__primary');
  const secondary = card.querySelector('.legacy-collection-preview__secondary');
  const frame = card.querySelector('.legacy-collection-preview__image');
  const title = card.querySelector('h3').textContent.trim();
  const backFirst = card.dataset.backFirst === 'true';
  card.querySelectorAll('a[href*="launch_item="]').forEach(link=>{const url=new URL(link.href);url.searchParams.set('launch_color',swatch.dataset.color);link.href=url.pathname+url.search;});
  primary.src = backFirst ? swatch.dataset.back : swatch.dataset.front;
  primary.alt = title + ', ' + swatch.dataset.color;
  if (secondary && swatch.dataset.back) {
    secondary.src = backFirst ? swatch.dataset.front : swatch.dataset.back;
    secondary.alt = title + ', ' + swatch.dataset.color;
  }
  frame.classList.toggle('legacy-collection-preview__image--alternate', !!swatch.dataset.back);
  if (secondary) secondary.hidden = !swatch.dataset.back;
  card.querySelectorAll('.legacy-preview-swatch').forEach(button => button.setAttribute('aria-pressed', String(button === swatch)));
  card.querySelector('[data-selected-color]').textContent = swatch.dataset.color;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legacy-custom-jersey"]) return;
  try {
    
function initializeLegacyJersey(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const form = root.querySelector('[data-group-form]');
  const sizes = Array.from(root.querySelectorAll('[data-variant]'));
  const details = Array.from(root.querySelectorAll('[data-design]'));
  const button = root.querySelector('[data-submit]');
  const error = root.querySelector('[data-error-message]');
  const buttonText = button.textContent;
  const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: root.dataset.currency });
  let busy = false;
  function update() {
    let total = 0, subtotal = 0;
    sizes.forEach(input => {
      const quantity = Number(input.value);
      if (!input.disabled && Number.isSafeInteger(quantity) && quantity >= 0) {
        total += quantity;
        subtotal += quantity * Number(input.dataset.price);
      }
    });
    root.querySelector('[data-total]').textContent = total;
    root.querySelector('[data-subtotal]').textContent = money.format(subtotal / 100);
    return total;
  }
  form.addEventListener('input', event => {
    if (event.target.matches('[data-design]')) event.target.setCustomValidity('');
    error.hidden = true;
    update();
  });
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy) return;
    details.forEach(input => input.setCustomValidity(input.value.trim() ? '' : root.dataset.invalid));
    if (!form.reportValidity()) return;
    const invalidQuantity = sizes.some(input => !input.disabled && (!Number.isSafeInteger(Number(input.value)) || Number(input.value) < 0));
    const total = update();
    if (invalidQuantity || total < 1) {
      error.textContent = invalidQuantity ? root.dataset.invalid : root.dataset.minimum;
      error.hidden = false;
      return;
    }
    const properties = Object.fromEntries(details.map(input => [input.dataset.design, input.value.trim()]));
    properties['Group request'] = crypto.randomUUID();
    const items = sizes.filter(input => !input.disabled && Number(input.value) > 0).map(input => ({id: input.dataset.variant, quantity: Number(input.value), properties: {...properties}}));
    busy = true;
    button.disabled = true;
    button.textContent = root.dataset.adding;
    try {
      const response = await fetch(root.dataset.addUrl, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || root.dataset.error);
      window.location.assign(root.dataset.cartUrl);
    } catch (failure) {
      error.textContent = root.dataset.error + (failure.message ? ' ' + failure.message : '');
      error.hidden = false;
      busy = false;
      button.disabled = false;
      button.textContent = buttonText;
    }
  });
  button.disabled = false;
  update();
}
document.querySelectorAll('[data-custom-jersey]').forEach(initializeLegacyJersey);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-custom-jersey]').forEach(initializeLegacyJersey));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legacy-product-preview"] && !Shopify.designMode) return;
  try {
    
function initializeLegacyProductPreview(){
  const root=document.querySelector('[data-launch-detail]');
  if(!root||root.dataset.initialized)return;
  const params=new URLSearchParams(window.location.search);
  const handle=params.get('launch_item');
  if(!handle)return;
  const catalog=JSON.parse(root.querySelector('[data-detail-catalog]').textContent);
  const product=catalog.find(item=>item.handle===handle);
  if(!product)return;
  const published=JSON.parse(root.querySelector('[data-live-products]').textContent);
  const live=published.find(item=>item.handle===handle);
  if(root.querySelector('[data-launch-ready]').dataset.launchReady==='true'&&live){const target=new URL(live.url,location.origin);const id=params.get('launch_variant');if(id)target.searchParams.set('variant',id);location.replace(target.href);return;}
  root.dataset.initialized='true';
  const labels=JSON.parse(root.querySelector('[data-detail-labels]').textContent);
  root.hidden=false;document.body.classList.add('legacy-detail-open');
  root.querySelector('[data-detail-title]').textContent=product.title;
  document.title=product.title+' | Legacy Collection';
  const image=root.querySelector('[data-detail-image]');
  const thumbnails=root.querySelector('[data-detail-thumbnails]');
  function setImage(url){const index=product.images.findIndex(item=>item.url===url);root.querySelector('[data-gallery-count]').textContent=(index+1)+' / '+product.images.length;image.src=url;image.alt=product.title;thumbnails.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.image===url)));}
  product.images.forEach((item,index)=>{const button=document.createElement('button');button.type='button';button.dataset.image=item.url;button.setAttribute('aria-label',labels.image+' '+(index+1));const thumb=document.createElement('img');thumb.src=item.url;thumb.alt=item.altText||product.title;thumb.loading='lazy';button.append(thumb);button.addEventListener('click',()=>setImage(item.url));thumbnails.append(button);});
  if(product.images.length)setImage(product.images[0].url);
  root.querySelector('[data-gallery-prev]').addEventListener('click',()=>{let i=product.images.findIndex(item=>item.url===image.getAttribute('src'));setImage(product.images[(i-1+product.images.length)%product.images.length].url);});
  root.querySelector('[data-gallery-next]').addEventListener('click',()=>{let i=product.images.findIndex(item=>item.url===image.getAttribute('src'));setImage(product.images[(i+1)%product.images.length].url);});
  const guide=product.images.find(item=>/size-guide/i.test(item.url));
  root.querySelectorAll('[data-size-guide]').forEach(button=>{button.hidden=!guide;button.addEventListener('click',()=>{setImage(guide.url);image.scrollIntoView({behavior:'smooth',block:'center'});});});
  const preorderText=root.querySelector('[data-detail-preorder]');preorderText.hidden=false;preorderText.textContent=product.handle.startsWith('never-off-duty-cap-')?labels.hatShipping:labels.itemShipping;root.querySelector('.legacy-product-preview__status').textContent=product.handle.startsWith('never-off-duty-cap-')?labels.hatDeadline:labels.itemDeadline;
  const pieces=root.querySelector('[data-detail-pieces]');
  if(product.pieces&&product.pieces.length){pieces.hidden=false;product.pieces.forEach(piece=>{const li=document.createElement('li'),a=document.createElement('a');const component=catalog.find(item=>item.handle===piece.handle);if(component&&component.images.length){const thumb=document.createElement('img');thumb.src=component.images[0].url;thumb.alt=piece.title;thumb.loading='lazy';thumb.width=220;thumb.height=220;a.append(thumb);}const label=document.createElement('span');label.textContent=piece.title;a.append(label);const url=new URL(location.href);url.searchParams.set('launch_item',piece.handle);url.searchParams.delete('launch_variant');url.searchParams.delete('launch_color');a.href=url.pathname+url.search;li.append(a);pieces.querySelector('ul').append(li);});}
  const doc=new DOMParser().parseFromString(product.descriptionHtml,'text/html');
  doc.querySelectorAll('script,iframe,object,embed,form').forEach(el=>el.remove());
  doc.querySelectorAll('*').forEach(el=>Array.from(el.attributes).forEach(a=>{if(a.name.startsWith('on')||((a.name==='href'||a.name==='src')&&/^javascript:/i.test(a.value)))el.removeAttribute(a.name);}));
  root.querySelector('[data-detail-description]').append(...Array.from(doc.body.childNodes));
  const options=root.querySelector('[data-detail-options]');
  product.options.forEach((option,index)=>{const field=document.createElement('div');const label=document.createElement('label');const select=document.createElement('select');select.id='LaunchOption-'+index;select.dataset.option=option.name;label.htmlFor=select.id;label.textContent=option.name;option.values.forEach(value=>{const o=document.createElement('option');o.value=value;o.textContent=value;select.append(o);});const chosen=params.get('launch_color');select.value=option.name.toLowerCase().startsWith('color')&&option.values.includes(chosen)?chosen:product.variants[0].selectedOptions.find(v=>v.name===option.name)?.value||option.values[0];select.addEventListener('change',updateSelection);field.append(label,select);options.append(field);});
  function updateSelection(){const selected=Array.from(options.querySelectorAll('select')).map(s=>({name:s.dataset.option,value:s.value}));const variant=product.variants.find(v=>selected.every(s=>v.selectedOptions.some(o=>o.name===s.name&&o.value===s.value)));root.querySelector('[data-detail-selection]').textContent=variant?labels.selected+' '+selected.map(s=>s.value).join(' / '):labels.unavailable;const notify=root.querySelector('[data-detail-notify]');if(notify)notify.disabled=!variant;if(variant){const url=new URL(location.href);url.searchParams.set('launch_variant',variant.id.split('/').pop());const color=variant.selectedOptions.find(o=>o.name.toLowerCase().startsWith('color'));if(color)url.searchParams.set('launch_color',color.value);history.replaceState(null,'',url.pathname+url.search);root.querySelector('[data-detail-price]').textContent=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:'USD'}).format(Number(variant.price));if(variant.image){const back=product.backImages&&color&&product.backImages[color.value];setImage(back||variant.image);}root.querySelector('[data-detail-tags]').value='newsletter,launch-2026-10-10,launch-product-'+product.handle+',launch-variant-'+variant.id.split('/').pop();}}
  updateSelection();
  root.querySelector('form').addEventListener('submit',()=>{root.querySelector('[data-detail-return]').value=location.pathname+location.search+'#'+root.querySelector('.legacy-product-preview__notify').id;});
  root.querySelector('[data-detail-return]').value=window.location.pathname+window.location.search+'#'+root.querySelector('.legacy-product-preview__notify').id;
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initializeLegacyProductPreview);else initializeLegacyProductPreview();
document.addEventListener('shopify:section:load',initializeLegacyProductPreview);

  } catch(e) { console.error(e); }
})();
})();
